/** Close enough to read the surrounding streets once a store has been picked. */
export const SELECTED_STORE_ZOOM = 15;
